import Image from "../../components/Atomos/Icons/Image";
import Video from "../../components/Atomos/Icons/Video";
import Folder from "../../components/Atomos/Icons/EditMode/Folder";
import type { IHelpCenterSubSection } from "../../interfaces/models/IHelpCenter";
import HelpCenterEditUploadBox from "./HelpCenterEditUploadBox";

type HelpCenterEditSectionMediaPanelsProps = {
  subSection: IHelpCenterSubSection;
  onUpload: (file: File, onUrl: (url: string) => void) => void | Promise<void>;
  onUpdate: (
    updater: (current: IHelpCenterSubSection) => IHelpCenterSubSection,
  ) => void;
};

export function HelpCenterEditTutorialPanel({
  subSection,
  onUpload,
  onUpdate,
}: HelpCenterEditSectionMediaPanelsProps) {
  return (
    <div className="help-center-edit-media-group help-center-edit-step-pair-media">
      <h2 className="help-center-edit-media-title">Watch the Tutorial</h2>
      <div className="help-center-edit-media-grid">
        <HelpCenterEditUploadBox
          label="Thumbnail"
          icon={<Image />}
          accept="image/*"
          previewUrl={subSection.tutorial?.thumbnailUrl}
          showHint={false}
          labelPlacement="below"
          dropzoneClassName="help-center-edit-upload-dropzone-media-slot"
          onFileSelected={(file) =>
            onUpload(file, (url) =>
              onUpdate((current) => ({
                ...current,
                tutorial: {
                  ...current.tutorial,
                  thumbnailUrl: url,
                },
              })),
            )
          }
          onClear={() =>
            onUpdate((current) => ({
              ...current,
              tutorial: {
                ...current.tutorial,
                thumbnailUrl: undefined,
              },
            }))
          }
        />
        <HelpCenterEditUploadBox
          label="Video"
          icon={<Video />}
          accept="video/*,.mp4,.webm,.mov"
          previewMode="file"
          fileKind="video"
          previewUrl={subSection.tutorial?.mediaUrl}
          showHint={false}
          labelPlacement="below"
          dropzoneClassName="help-center-edit-upload-dropzone-media-slot"
          onFileSelected={(file) =>
            onUpload(file, (url) =>
              onUpdate((current) => ({
                ...current,
                tutorial: {
                  ...current.tutorial,
                  mediaUrl: url,
                },
              })),
            )
          }
          onClear={() =>
            onUpdate((current) => ({
              ...current,
              tutorial: {
                ...current.tutorial,
                mediaUrl: undefined,
              },
            }))
          }
        />
      </div>
    </div>
  );
}

export function HelpCenterEditPdfPanel({
  subSection,
  onUpload,
  onUpdate,
}: HelpCenterEditSectionMediaPanelsProps) {
  return (
    <div className="help-center-edit-media-group help-center-edit-step-pair-media">
      <h2 className="help-center-edit-media-title">Download PDF Instructions</h2>
      <div className="help-center-edit-media-grid">
        <HelpCenterEditUploadBox
          label="Thumbnail"
          icon={<Image />}
          accept="image/*"
          previewUrl={subSection.pdfDownload?.thumbnailUrl}
          showHint={false}
          labelPlacement="below"
          dropzoneClassName="help-center-edit-upload-dropzone-media-slot"
          onFileSelected={(file) =>
            onUpload(file, (url) =>
              onUpdate((current) => ({
                ...current,
                pdfDownload: {
                  ...current.pdfDownload,
                  thumbnailUrl: url,
                },
              })),
            )
          }
          onClear={() =>
            onUpdate((current) => ({
              ...current,
              pdfDownload: {
                ...current.pdfDownload,
                thumbnailUrl: undefined,
              },
            }))
          }
        />
        <HelpCenterEditUploadBox
          label="PDF"
          icon={<Folder />}
          accept=".pdf,application/pdf"
          previewMode="file"
          fileKind="pdf"
          previewUrl={subSection.pdfDownload?.mediaUrl}
          showHint={false}
          labelPlacement="below"
          dropzoneClassName="help-center-edit-upload-dropzone-media-slot"
          onFileSelected={(file) =>
            onUpload(file, (url) =>
              onUpdate((current) => ({
                ...current,
                pdfDownload: {
                  ...current.pdfDownload,
                  mediaUrl: url,
                },
              })),
            )
          }
          onClear={() =>
            onUpdate((current) => ({
              ...current,
              pdfDownload: {
                ...current.pdfDownload,
                mediaUrl: undefined,
              },
            }))
          }
        />
      </div>
    </div>
  );
}
